import { Component, OnInit, Input } from '@angular/core';
import { PolynomialCalMethodViewModel, CalculationMethodType } from '../../model/measurement-points.model';

@Component({
  selector: 'ploynomial-cal-method',
  templateUrl: './ploynomial-cal-method.component.html',
  styleUrls: ['./ploynomial-cal-method.component.scss']
})
export class PloynomialCalMethodComponent implements OnInit {


  @Input() ployCalModel: PolynomialCalMethodViewModel;

  constructor() { }

  ngOnInit() {
    if(this.ployCalModel==undefined)
    this.ployCalModel = new PolynomialCalMethodViewModel();
  }

  saveChanges() {
    

  }
}
